/* =============================================
   SEA PLAY HOMES – THEME JAVASCRIPT
   ============================================= */

(function() {
  'use strict';

  // ---- MOBILE MENU ----
  const mobileMenuBtn = document.getElementById('mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileClose = document.getElementById('mobile-close');

  if (mobileMenuBtn && mobileMenu) {
    mobileMenuBtn.addEventListener('click', () => {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      mobileMenuBtn.setAttribute('aria-expanded', 'true');
    });
    mobileClose && mobileClose.addEventListener('click', closeMenu);
    function closeMenu() {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
      mobileMenuBtn.setAttribute('aria-expanded', 'false');
    }
  }

  // ---- FAQ ACCORDION ----
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(el => el.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ---- PRODUCT GALLERY ----
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('.product-gallery');
      const mainImg = gallery.querySelector('.product-main-image img');
      const src = thumb.querySelector('img').src;
      if (mainImg) {
        mainImg.src = src;
        gallery.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });



  // ---- CART CUSTOM FIELDS VALIDATION ----
  const checkoutBtn = document.getElementById('checkout-btn');
  const deliveryDate = document.getElementById('delivery-date');
  const pickupDate = document.getElementById('pickup-date');

  if (checkoutBtn) {
    // Set minimum date to today
    const today = new Date().toISOString().split('T')[0];
    if (deliveryDate) deliveryDate.min = today;
    if (pickupDate) pickupDate.min = today;

    // Validate pickup > delivery
    if (deliveryDate && pickupDate) {
      deliveryDate.addEventListener('change', () => {
        pickupDate.min = deliveryDate.value || today;
        if (pickupDate.value && pickupDate.value < deliveryDate.value) {
          pickupDate.value = '';
        }
      });
    }

    checkoutBtn.addEventListener('click', (e) => {
      let valid = true;

      // Validate delivery date
      if (deliveryDate && !deliveryDate.value) {
        e.preventDefault();
        deliveryDate.classList.add('error');
        const err = document.getElementById('delivery-date-error');
        if (err) err.classList.add('visible');
        valid = false;
      } else if (deliveryDate) {
        deliveryDate.classList.remove('error');
        const err = document.getElementById('delivery-date-error');
        if (err) err.classList.remove('visible');
      }

      // Validate pickup date
      if (pickupDate && !pickupDate.value) {
        e.preventDefault();
        pickupDate.classList.add('error');
        const err = document.getElementById('pickup-date-error');
        if (err) err.classList.add('visible');
        valid = false;
      } else if (pickupDate) {
        pickupDate.classList.remove('error');
        const err = document.getElementById('pickup-date-error');
        if (err) err.classList.remove('visible');
      }

      if (!valid) {
        // Scroll to fields
        const firstError = document.querySelector('.form-input.error');
        if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      // Attach cart attributes via AJAX before redirect
      if (valid) {
        e.preventDefault();
        saveCartAttributesAndCheckout();
      }
    });
  }

  function saveCartAttributesAndCheckout() {
    const deliveryVal = document.getElementById('linen-delivery-date')?.value || '';
    const pickupVal = document.getElementById('pickup-date')?.value || '';
    const noteVal = document.getElementById('order-note')?.value || '';
    const addressVal = document.getElementById('delivery-address')?.value || '';

    // Format dates nicely
    const formatDate = (dateStr) => {
      if (!dateStr) return '';
      const d = new Date(dateStr + 'T00:00:00');
      return d.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    };

    const attributes = {
      'Linen Delivery Date': formatDate(deliveryVal),
      'Pickup Date': formatDate(pickupVal),
    };
    if (addressVal) attributes['Delivery Address'] = addressVal;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: attributes,
        note: noteVal
      })
    })
    .then(res => res.json())
    .then(() => {
      window.location.href = '/checkout';
    })
    .catch(() => {
      window.location.href = '/checkout';
    });
  }

  // ---- CONTACT FORM ----
  const contactForm = document.getElementById('contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = contactForm.querySelector('[type="submit"]');
      const successMsg = document.getElementById('contact-success');

      btn.textContent = 'Sending...';
      btn.disabled = true;

      // Shopify contact form submission
      const formData = new FormData(contactForm);
      fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(res => {
        if (successMsg) {
          successMsg.style.display = 'block';
          contactForm.reset();
        }
        btn.textContent = 'Message Sent!';
      })
      .catch(() => {
        btn.textContent = 'Send Message';
        btn.disabled = false;
        alert('There was an error. Please email us directly at linens@seaplayhomes.com');
      });
    });
  }

  // ---- SMOOTH SCROLL ----
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ---- STICKY HEADER SHADOW ----
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    window.addEventListener('scroll', () => {
      siteHeader.classList.toggle('scrolled', window.scrollY > 10);
    });
  }

  // ---- ANIMATE ON SCROLL ----
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.step, .product-card, .testimonial-card, .why-card, .service-area-card, .category-card').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    observer.observe(el);
  });

  document.addEventListener('animateIn', (e) => {
    if (e.target.classList.contains('animate-in')) {
      e.target.style.opacity = '1';
      e.target.style.transform = 'translateY(0)';
    }
  });

  // Trigger animation
  document.querySelectorAll('.animate-in').forEach(el => {
    el.style.opacity = '1';
    el.style.transform = 'translateY(0)';
  });

  // Watch for class additions
  const animObserver = new MutationObserver((mutations) => {
    mutations.forEach(m => {
      if (m.type === 'attributes' && m.attributeName === 'class') {
        const el = m.target;
        if (el.classList.contains('animate-in')) {
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        }
      }
    });
  });

  document.querySelectorAll('.step, .product-card, .testimonial-card, .why-card, .service-area-card, .category-card').forEach(el => {
    animObserver.observe(el, { attributes: true });
  });

})();
